export const TransitionSteps = {
  COMMON: {
    INITIAL_STATE: 'initialState',
    ORDER_FINALIZED_STATE: 'orderFinalizedState',
    CONFIRM_ORDER_STATE: 'confirmOrderState',
    USER_LOGIN_STATE: 'userLoginState',
  },
  OTT: {
    PAYMENT_OPTION_STATE: 'paymentOptionState',
    CONFIRM_ORDER_STATE: 'confirmOrderState',
  },
  POST_OTT: {
    PERSONAL_DATA_STATE: 'personalDataState',
    BILLING_ADDRESS_STATE: 'billingAddressState',
    DELIVERY_ADDRESS_STATE: 'deliveryAddressState',
    CONFIRM_ORDER_STATE: 'confirmOrderState',
  },
  FTTH: {
    FEASIBILITY_CHECK_STATE: 'feasibilityCheckState',
    NOT_FEASIBLE_STATE: 'notFeasibleState',
    ORDER_TERMINATED_STATE: 'orderTerminatedState',
    PERSONAL_DATA_STATE: 'personalDataState',
    CONFIRM_ORDER_STATE: 'confirmOrderState',
    OPERATOR_PROFILE_STATE: 'operatorProfileState',
    BILLING_ADDRESS_STATE: 'billingAddressState',
    ADDITIONAL_CONDITIONS_STATE: 'additionalConditionsState',
    CHOOSE_NUMBER_STATE: 'chooseNumberState',
  },
  TELCO: {
    CHOOSE_NUMBER_STATE: 'chooseNumberState',
    CUSTOMER_CHECK_STATE: 'customerCheckPersonalDataState',
    PAYMENT_OPTION_STATE: 'customerCheckPaymentOptionsState',
    PERSONAL_DATA_STATE: 'personalDataState',
    INTEREST_ADDRESS_STATE: 'interestAddressState',
    CONFIRM_ORDER_STATE: 'confirmOrderState',
    DELIVERY_INFO_STATE: 'deliveryInfoState',
  },
  ACCESSORY: {
    CUSTOMER_CHECK_STATE: 'customerCheckPersonalDataState',
    CHOOSE_EXISTING_NUMBER: 'chooseNumberState',
    PAYMENT_OPTION_STATE: 'paymentOptionState',
    PERSONAL_DATA_STATE: 'personalDataState',
    DELIVERY_INFO_STATE: 'deliveryInfoState',
  },
  COMPLEX: {
    CUSTOMER_CHECK_STATE: 'customerCheckPersonalDataState',
    CHOOSE_NUMBER_STATE: 'chooseNumberState',
    PAYMENT_OPTION_STATE: 'customerCheckPaymentOptionsState',
    PERSONAL_DATA_STATE: 'personalDataState',
    DELIVERY_INFO_STATE: 'deliveryInfoState',
  },
  P2PDJ: {
    PERSONAL_DATA_STATE: "personalDataState",
    CONFIRM_ORDER_STATE: "confirmOrderState",
  },
};
